import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import RFPI from "../BaseControls/FileField/RFPI";
import { controlPropTypes } from "../formhelpers";

export default class Rfpi extends React.Component {
    render() {
        return (
            <ControlTemplate {...this.props} className="rfpi-file-field">
                <RFPI {...this.props} />
            </ControlTemplate>
        );
    }
}

Rfpi.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/FileField/rfpi.js